var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgTrashIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3333 2.99967H13.1666C13.4427 2.99967 13.6666 3.22353 13.6666 3.49967V3.83301C13.6666 4.10915 13.4427 4.33301 13.1666 4.33301H12.3333V12.9997C12.3333 13.1765 12.263 13.3461 12.138 13.4711C12.013 13.5961 11.8434 13.6663 11.6666 13.6663H2.33325C2.15644 13.6663 1.98687 13.5961 1.86185 13.4711C1.73682 13.3461 1.66659 13.1765 1.66659 12.9997V4.33301H0.833252C0.55711 4.33301 0.333252 4.10915 0.333252 3.83301V3.49967C0.333252 3.22353 0.55711 2.99967 0.833252 2.99967H3.66659V0.999674C3.66659 0.822863 3.73682 0.653294 3.86185 0.52827C3.98687 0.403246 4.15644 0.333008 4.33325 0.333008H9.66659C9.8434 0.333008 10.013 0.403246 10.138 0.52827C10.263 0.653294 10.3333 0.822863 10.3333 0.999674V2.99967ZM10.9999 4.33301H2.99992V12.333H10.9999V4.33301ZM4.99992 1.66634V2.99967H8.99992V1.66634H4.99992Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTrashIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/TrashIcon.b74e2b01.svg";
export { ForwardRef as ReactComponent };